<template>
  <section>
    <table class="unstriped hover boss-table">
      <thead>
        <tr data-test="head">
          <th class="boss-table-head-center">
            求人ID
          </th>
          <th class="boss-table-head-center">
            管理用求人名
          </th>
          <th class="boss-table-head-center">
            求人名
          </th>
          <th class="boss-table-head-center">
            掲載期間
          </th>
          <th class="boss-table-head-center">
            掲載<br>サイズ
          </th>
          <th class="boss-table-head-center">
            プレビュー
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(object, i) in renderingObjects">
          <preview-job-published-job
            :key="i"
            :job="object"
            :is-publishing="false"
          />
        </template>
        <infinite-loading
          v-if="!isClosed"
          @infinite="infiniteHandler"
        >
          <div slot="no-more" />
          <div slot="no-results" />
        </infinite-loading>
        <tr v-if="renderingObjects.length==0">
          <td
            colspan="8"
            data-test="no-job-label"
          >
            ※過去の求人情報プレビューはありません
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="isExistsMoreObjects"
      class="text-center"
      :class="{'pega-past-more-close-button': !isClosed}"
      data-test="button"
    >
      <button
        class="boss-button-center boss-button-large margin-top-1 margin-bottom-1"
        data-test="more-close-button"
        @click="isClosed = !isClosed"
      >
        {{ isClosed ? 'もっと見る' : '閉じる' }}
      </button>
    </div>
  </section>
</template>

<script>
import PreviewJobPublishedJob from '@/components/molecules/PreviewJobPublishedJob'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import _ from 'lodash'

export default {
  components: {
    PreviewJobPublishedJob,
    InfiniteLoading
  },
  props: {
    recentPastJobs: {
      type: Array,
      required: true
    },
    pastJobs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isClosed: true,
      infinityObjects: []
    }
  },
  computed: {
    renderingObjects () {
      return this.isClosed ? this.recentPastJobs : this.infinityObjects
    },
    isExistsMoreObjects () {
      return !_.isEqual(this.recentPastJobs, this.pastJobs)
    }
  },
  watch: {
    pastJobs (val) {
      this.initialInfinityScrollIterator(val)
    }
  },
  methods: {
    initialInfinityScrollIterator (val) {
      this.infinityObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(val, 50)
      this.infinityObjects.push(...this.infinityScrollIterator.next().value)
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.infinityObjects.push(...next.value)
          $state.loaded()
        }
      }
    }
  }
}
</script>
